import angular from 'angular';
import { HistoricosLancamentosService } from './Lancamentos/historicosLancamentos.service';
import { HistoricosMudancastrabalhadoresService } from './Mudancastrabalhadores/historicosmudancastrabalhadores.service';
import { HistoricosReajustesTrabalhadoresService } from './Reajustestrabalhadores/reajustestrabalhadores.service';
import { FaltastrabalhadoresService } from '../Faltastrabalhadores/faltastrabalhadores.service';

export class HistoricosController {

    static $inject = [
        '$scope',
        '$stateParams',
        'HistoricosLancamentosService',
        'HistoricosMudancastrabalhadoresService',
        'HistoricosReajustesTrabalhadoresService',
        'FaltastrabalhadoresService'
    ];

    public totais: any;
    public entities: any;

    public tipo: string;
    public ano: number;
    public mes: string;

    public filtrosFalta: {
        tipo?: '0' | '1';
        periodo?: 'PORDATA' | 'ENTREDATAS';
        data?: string;
        dataFim?: string
    } = {};

    private _trabalhador: string;

    constructor(
        public $scope: angular.IScope,
        public $stateParams: angular.ui.IStateParamsService,
        public HistoricosLancamentos: HistoricosLancamentosService,
        public HistoricosMudancastrabalhadores: HistoricosMudancastrabalhadoresService,
        public HistoricosReajustesTrabalhadoresService: HistoricosReajustesTrabalhadoresService,
        public FaltastrabalhadoresService: FaltastrabalhadoresService,
    ) {
        HistoricosLancamentos.constructors = [];
        HistoricosMudancastrabalhadores.constructors = [];
        HistoricosReajustesTrabalhadoresService.constructors = [];
        FaltastrabalhadoresService.constructors = [];

        $scope.$on('historicos_lancamentos_list_finished', (event, entities) => {
            this.totais = entities.reduce((total, elem) => {
                total['descontos'] = total['descontos'] || 0;
                total['proventos'] = total['proventos'] || 0;
                if (elem.evento.tipovalor === 1) {
                    total['descontos'] = parseFloat(total['descontos']) + parseFloat(elem.valorbruto);
                } else {
                    total['proventos'] = parseFloat(total['proventos']) + parseFloat(elem.valorbruto);
                }

                return total;
            }, []);
        });
    }

    set trabalhador(trabalhador: string) {
        this._trabalhador = trabalhador;
    }

    get trabalhador() {
        return this._trabalhador;
    }

    tipoChange() {
        this.entities = [];
        this.filtra();
    }

    isBusy() {
        return this.HistoricosLancamentos.loadParams.busy ||
            this.HistoricosMudancastrabalhadores.loadParams.busy ||
            this.HistoricosReajustesTrabalhadoresService.loadParams.busy ||
            this.FaltastrabalhadoresService.loadParams.busy;
    }

    filtra() {
        switch (this.tipo) {
            case 'lancamentos':
                this.filtraLancamentos();
                break;
            case 'faltas':
                this.filtraFaltas();
                break;
            case 'funcoes':
                this.HistoricosMudancastrabalhadores.constructors['tipo'] = 2;
                this.filtraMudancastrabalhadores();
                break;
            case 'jornadas':
                this.HistoricosMudancastrabalhadores.constructors['tipo'] = 5;
                this.filtraMudancastrabalhadores();
                break;
            case 'lotacoes':
                this.HistoricosMudancastrabalhadores.constructors['tipo'] = 6;
                this.filtraMudancastrabalhadores();
                break;
            case 'salarios':
                this.filtraReajustestrabalhadores();
                break;
        }
    }

    filtraLancamentos() {
        this.HistoricosLancamentos.constructors['ano'] = this.ano;
        this.HistoricosLancamentos.constructors['mes'] = this.mes;
        this.HistoricosLancamentos.constructors['trabalhador'] = this._trabalhador;
        if (this.ano && this.mes) {
            this.entities = this.HistoricosLancamentos.search(null);
        }
    }

    filtraMudancastrabalhadores() {
        this.HistoricosMudancastrabalhadores.constructors['trabalhador'] = this._trabalhador;
        this.entities = this.HistoricosMudancastrabalhadores.search(undefined);
    }

    filtraReajustestrabalhadores() {
        this.HistoricosReajustesTrabalhadoresService.constructors['trabalhador'] = this._trabalhador;
        this.entities = this.HistoricosReajustesTrabalhadoresService.search(undefined);
    }

    /* Faltas */

    filtraFaltas() {
        if (!this.filtrosFalta.tipo) {
            return;
        }
        this.FaltastrabalhadoresService.constructors['trabalhador'] = this._trabalhador;
        this.FaltastrabalhadoresService.constructors['tipo'] = this.filtrosFalta.tipo;
        this.entities = this.FaltastrabalhadoresService.search(undefined);
    }

    periodoChange() {
        this.filtrosFalta.data = undefined;
        this.filtrosFalta.dataFim = undefined;
        this.FaltastrabalhadoresService.constructors = {};
        if (this.filtrosFalta.periodo) {
            return;
        }
        this.filtra();
    }

    periodoPorData() {
        if (!this.filtrosFalta.data) {
            return;
        }
        this.FaltastrabalhadoresService.constructors['data'] = [
            { condition: 'gte', value: this.filtrosFalta.data },
        ];
        this.filtra();
    }

    periodoEntreDatas() {
        if (!this.filtrosFalta.data || !this.filtrosFalta.dataFim) {
            return;
        }
        this.FaltastrabalhadoresService.constructors['data'] = [
            { condition: 'gte', value: this.filtrosFalta.data },
            { condition: 'lte', value: this.filtrosFalta.dataFim },
        ];
        this.filtra();
    }
}

angular.module('main').controller('HistoricosController', HistoricosController);
